import {
  Box,
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React from "react";
import { Controller, useFieldArray, useWatch } from "react-hook-form";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build";
import MainDirectorSelectedFilmographySections from "../MainDirectorSelectedFilmography";
import UploadImage from "../../UploadImage";
import editorConfiguration from "../../../../util/EditorConfiguration";

const directorDefaultValue = {
  desc: "",
  img: "",
  filmography: [],
};

const useStyles = makeStyles((theme) => ({
  innerBox: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
    background: "#ffffff",
  },
  deleteBtn: {
    margin: "0",
    padding: "0",
    minWidth: "initial",
    float: "right",
  },
}));

const DirectorBlock = ({
  control,
  index,
  classes,
  disabled,
  remove,
  data,
  dataTc,
  getValues,
  setValue,
  isRemoveDirector,
  setIsRemoveDirector,
}) => {
  return (
    <>
      <Box className={classes.innerBox}>
        <Box fontWeight={900} fontSize={13} mb={2} width="100%">
          <Typography variant="p">Directors</Typography>
          {disabled || (
            <Button
              className={classes.deleteBtn}
              onClick={() => {
                remove(index);
                setValue(
                  `localizations.tc.directors.directors[${index}].desc`,
                  ""
                );
                setIsRemoveDirector(index);
              }}
            >
              <Close
                style={{
                  fontSize: "14px",
                  lineHeight: "16px",
                }}
              />
            </Button>
          )}
        </Box>

        <Box fontWeight={900} fontSize={13} mb={2} ml={2} width="100%">
          <Typography variant="p">Director Photo</Typography>
        </Box>
        <Grid container direction="vertical" spacing={3}>
          <Grid item xs={6}>
            <UploadImage
              name={`localizations.en.directors.directors[${index}].img`}
              data={data}
              control={control}
              Controller={Controller}
              setValue={setValue}
              getValues={getValues}
              disabled={disabled}
              uploadLabel="Upload Director Photo"
              changeLabel="Change Director Photo"
              uploadFolder="FILM"
            />
          </Grid>

          <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
            <Typography variant="p">Description (English)</Typography>
          </Box>

          <Grid item xs={12}>
            <Controller
              defaultValue={data?.desc}
              name={`localizations.en.directors.directors[${index}].desc`}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <CKEditor
                  editor={Editor}
                  config={editorConfiguration}
                  data={field.value}
                  disabled={disabled}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log("Editor is ready to use!", editor);
                    // editor.setData(initialValues.terms.valueEn);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    field.onChange(data);
                    // console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log("Blur.", editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log("Focus.", editor);
                  }}
                />
              )}
            />
          </Grid>

          <Box fontWeight={900} fontSize={13} mb={1} ml={2} width="100%">
            <Typography variant="p">
              Description (Traditional Chinese)
            </Typography>
          </Box>

          <Grid item xs={12}>
            <Controller
              defaultValue={dataTc?.desc}
              name={`localizations.tc.directors.directors[${index}].desc`}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <CKEditor
                  editor={Editor}
                  config={editorConfiguration}
                  data={field.value}
                  disabled={disabled}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log("Editor is ready to use!", editor);
                    // editor.setData(initialValues.terms.valueEn);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    field.onChange(data);
                  }}
                  onBlur={(event, editor) => {
                    console.log("Blur.", editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log("Focus.", editor);
                  }}
                />
              )}
            />
          </Grid>

          <Box fontWeight={900} fontSize={13} mt={2} mb={1} ml={2} width="100%">
            <Typography variant="p">Selected Filmography</Typography>
          </Box>
          <Grid item xs={12}>
            <MainDirectorSelectedFilmographySections
              directorIndex={index}
              control={control}
              setValue={setValue}
              disabled={disabled}
              isRemoveDirector={isRemoveDirector}
              setIsRemoveDirector={setIsRemoveDirector}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default function DirectorSection(props) {
  const { control, getValues, setValue, disabled } = props;

  const [isRemoveDirector, setIsRemoveDirector] = React.useState(false);

  const { fields, append, remove } = useFieldArray({
    control,
    name: `localizations.en.directors.directors`,
  });
  
  const { fields: fieldsTc, append: appendTc, remove: removeTc } = useFieldArray({
    control,
    name: `localizations.tc.directors.directors`,
  });

  const classes = useStyles();

  const removeDirector = (index) => {
    remove(index);
    removeTc(index);
  }

  return (
    <>
      {fields.map((data, index) => (
        <div className={classes.filmScreeningsBlk} key={data.id}>
          {
            <DirectorBlock
              {...{
                control,
                index,
                classes,
                disabled,
                remove: removeDirector,
                data,
                dataTc: fieldsTc[index],
                getValues,
                setValue,
                isRemoveDirector,
                setIsRemoveDirector,
              }}
            />
          }
        </div>
      ))}

      {disabled || (
        <Button
          type="button"
          onClick={() => {
            append(directorDefaultValue);
            appendTc(directorDefaultValue);
          }}
          style={{
            color: "#306F9D",
            margin: "5px 0",
          }}
        >
          <AddCircleIcon />
          Add Director
        </Button>
      )}
    </>
  );
}
